import React from "react";
import { PeekTypography } from "@piiqtechnologies/ui-components";
export const PageHeaderTitle = ({ title }) => {
    return (React.createElement(PeekTypography, { variant: "h1", fontWeight: "500" }, title));
};
export default PageHeaderTitle;
